<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						강사배정
					</h2>
					<span class="close" @click="$emit('close')">&times;</span>
				</div>
				<div class="modal-body p-10 clearfix">
					<div class="send-search-box m-t-15 clearfix">
						<div class="search-box full-width">
							<input v-model="keyword"  id="search" class="form-control round full-width m-b-0" type="text" placeholder="강사 이름, 연락처, 이메일, 소속기관 등으로 검색하세요" @keyup.enter="getTeacherList()">
							<label @click="getTeacherList()" for="search">검색</label>
						</div>
					</div>
					<p class="m-t-15 m-b-0 clearfix">
						<span class="text-bold text-darkgray pull-left">검색결과</span>
						<span class="pull-right">총 {{teacher_list.length}}건</span>
					</p>
					<div class="list-box">
						<table class="full-width table-condensed table-hover text-center m-t-0 m-b-0">
							<tbody>
								<tr v-for="(item, idx) in teacher_list" :key="'teacher-'+idx+item.mberId">
									<td>{{item.workCode}}</td>
									<td>{{item.mberName}}</td>
									<td>{{item.mobileNum}}</td>
									<td>{{item.depart}}</td> <!-- 부서명-->
									<td>{{item.agencyId}}</td><!-- 기관 ID -->
									<td>
										<button @click="addItem(item)" class="btn-sm bg-deepblue text-white round">추가</button>
									</td>
								</tr>

							</tbody>
						</table>
					</div>
					<p class="m-t-15 m-b-0 clearfix">
						<span class="text-bold text-darkgray pull-left">강사배정</span>
					</p>
					<div class="list-box">
						<table class="full-width table-condensed table-hover text-center m-t-0 m-b-0">
							<tbody>
								<tr v-for="(item, idx) in add_list" :item="item" :index="idx" :key="'teacher-list-'+idx+hash(item)">
									<td>{{item.workCode}}</td>
									<td>{{item.mberName}}</td>
									<td>{{item.mobileNum}}</td>
									<td>{{item.depart}}</td> <!-- 부서명-->
									<td>{{item.agencyId}}</td><!-- 기관 ID -->
									<td>
										<a class="mail_" @click="modalMail(item)">메일</a>
										<a class="del" @click="removeItem(item)">삭제</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer p-10">
					<button class="btn bg-deepblue text-white full-width m-t-30 round" type="button" @click="$emit('assign',add_list)">강사배정</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server'
import _ from 'lodash'
export default {
	name: "ModalAssignTeacher",

	default: function() {
		return {
			lecId : '48',
			name: this.name,
			show: false
		}
	},

	mounted(){
		this.getTeacherList();
	},

	data(){
		return {
			teacher_list : [],
			add_list : [],
			keyword : '',
			modals: {
			}
		}
	},

	props: {
		config: Object
	},

	methods : {
		getTeacherList(){
			const self = this;
			let config = {
				instEnable : 1,
				keyword : this.keyword
			}
			server.postAxios('mber', config, ({data , err}) => {
				err;
				self.teacher_list = data.list || [];
			});
		},
		addItem(item){
			this.teacher_list = _.reject(this.teacher_list, {mberId : item.mberId});
			this.add_list.push(item);
		},
		removeItem(item){
			this.add_list = _.reject(this.add_list, {mberId : item.mberId});
			this.teacher_list.push(item);
		},
		modalMail(mber){
			// 메일 작성 모달 생성
			this.$emit('sendEmail', mber);
		}
	}

}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>